module.exports = __webpack_public_path__ + "img/slika8.64da97b7.jpg";